import { Link, useRoute } from '../lib/router';
import { useAuth } from '../context/AuthContext';
import { RESOURCES } from '../resources';
import logo from '../assets/logo.png';

const initials = (u) =>
  (u?.name || u?.email || '?')
    .split(/[\s@.]+/)
    .filter(Boolean)
    .slice(0, 2)
    .map((s) => s[0].toUpperCase())
    .join('');

// Group RESOURCES by `section` (default 'Main'), preserving first-seen order.
function groupBySection(resources) {
  const order = [];
  const groups = new Map();
  for (const r of resources) {
    const s = r.section || 'Main';
    if (!groups.has(s)) { groups.set(s, []); order.push(s); }
    groups.get(s).push(r);
  }
  return order.map((title) => ({ title, items: groups.get(title) }));
}

// Sidebar + header shell. Nav entries generated from RESOURCES.
export default function Layout({ children }) {
  const { path } = useRoute();
  const { user, signOut } = useAuth();
  const sections = groupBySection(RESOURCES);
  return (
    <div className="layout">
      <header className="topbar">
        <div className="topbar__brand">
          <img className="topbar__logo" src={logo} alt="TraveLens" />
          <span className="topbar__brand-name">TraveLens</span>
        </div>
        <div className="topbar__spacer" />
        <span className="topbar__user">
          <span className="topbar__avatar">{initials(user)}</span>
          <span className="topbar__user-text">
            <span className="topbar__user-name">{user?.name || user?.email}</span>
            <span className="topbar__user-sub">Admin</span>
          </span>
        </span>
        <button className="btn btn--ghost btn--onDark" onClick={signOut}>Sign out</button>
      </header>
      <div className="layout__body">
        <aside className="sidebar">
          <nav className="sidebar__nav">
            {sections.map((section) => (
              <div key={section.title} className="sidebar__group">
                <span className="sidebar__section">{section.title}</span>
                {section.items.map((r) => (
                  <Link key={r.key} to={r.path} className={`nav-item${path.startsWith(r.path) ? ' nav-item--active' : ''}`}>
                    {r.label}
                  </Link>
                ))}
              </div>
            ))}
          </nav>
          <div className="sidebar__footer">TraveLens AI · Admin Console</div>
        </aside>
        <main className="content">{children}</main>
      </div>
    </div>
  );
}
